import { render, staticRenderFns } from "./UploadedImages.vue?vue&type=template&id=6a8365fc&scoped=true"
import script from "./UploadedImages.vue?vue&type=script&lang=js"
export * from "./UploadedImages.vue?vue&type=script&lang=js"
import style0 from "./UploadedImages.vue?vue&type=style&index=0&id=6a8365fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8365fc",
  null
  
)

export default component.exports